import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import RichText from '../../../../../shared/RichText'
import { generateElementId } from '../../../../../../common/helpers'
import classNames from 'classnames'
import ArrowIcon from 'src/components/shared/ArrowIcon'
import { Section } from 'src/components/shared/SectionV2'
import { cn } from 'src/utils/cn'

const AccordionItem = ({
  title,
  content,
  opened,
  id,
  changeCollapse,
  iconClassName,
}) => {
  const handleClick = useCallback(
    () => changeCollapse(id),
    [changeCollapse, id]
  )

  const showTitle = () => {
    return (
      <Section.Typography
        as="h2"
        variant="heading-small"
        className={cn('text-left')}
        id={generateElementId(title)}
        data-testid="accordion-item-title"
      >
        {title}
      </Section.Typography>
    )
  }

  return (
    <div data-testid="accordion-item">
      <div
        className={cn(
          'relative flex cursor-pointer flex-row justify-between gap-2 border-t border-primary py-4 lg:items-center',
          opened && 'pb-5',
          id === 0 && 'border-0'
        )}
        onClick={handleClick}
        data-testid={`title_${id}`}
      >
        {title ? showTitle() : null}
        <div>
          <ArrowIcon
            className={classNames(
              'size-5 text-content-primary',
              iconClassName,
              opened && 'lg:mt-2'
            )}
            collapsed={opened}
            stroke="#2F2F2F"
            data-testid="arrow-icon"
          />
        </div>
      </div>
      <div
        data-testid="content-wrapper"
        className={`${styles.accordionContent} ${
          !opened ? styles.collapsed : ''
        }`}
      >
        <div data-testid="content" className="text-black wrap-break-word mb-4">
          <RichText contentData={content} />
        </div>
      </div>
    </div>
  )
}

AccordionItem.defaultProps = {
  opened: false,
  mobileRow: false,
}

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  opened: PropTypes.bool,
  id: PropTypes.number.isRequired,
  changeCollapse: PropTypes.func.isRequired,
  mobileRow: PropTypes.bool,
  iconClassName: PropTypes.string,
}

export default AccordionItem
